/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_O1Inputs */

const en_mk_sol_agensi_o1 = /** @type {(inputs: Mk_Sol_Agensi_O1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client decisions can be shown, not recalled from memory`)
};

const id_mk_sol_agensi_o1 = /** @type {(inputs: Mk_Sol_Agensi_O1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riwayat keputusan klien bisa ditunjukkan, bukan diingat-ingat`)
};

/**
* | output |
* | --- |
* | "Client decisions can be shown, not recalled from memory" |
*
* @param {Mk_Sol_Agensi_O1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_o1 = /** @type {((inputs?: Mk_Sol_Agensi_O1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_O1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_o1(inputs)
	return en_mk_sol_agensi_o1(inputs)
});